<template>
  <NavbarOne />
  <PageBanner
    pageTitle="من نحن"
    subTitle="خدمة ترفيهية متكاملة لمشاهدة القنوات العربية والعالمية والأفلام والمسلسلات بجودة عالية وثبات ممتاز"
    :pageBannerImage="pageBannerImg"
  />
  <WhoWeAre />
  <PoweringDailyLife />
  <OurMission />
  <OurVision />
  <PartnerLogo />
  <EnjoySports />
  <FanFact />
  <FAQ />
  <OurLatestArticles />
  <SubscribeContent />
  <MainFooter class="bg-black" />
  <CopyRight />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useHead } from "@unhead/vue";
import NavbarOne from "@/components/Layouts/NavbarOne.vue";
import PageBanner from "@/components/Common/PageBanner.vue";
import WhoWeAre from "@/components/AboutUs/WhoWeAre.vue";
import PoweringDailyLife from "@/components/AboutUs/PoweringDailyLife.vue";
import OurMission from "@/components/AboutUs/OurMission.vue";
import OurVision from "@/components/AboutUs/OurVision.vue";
import PartnerLogo from "@/components/AboutUs/PartnerLogo.vue";
import EnjoySports from "@/components/AboutUs/EnjoySports.vue";
import FanFact from "@/components/AboutUs/FanFact.vue";
import FAQ from "@/components/AboutUs/FAQ.vue";
import OurLatestArticles from "@/components/Common/OurLatestArticles.vue";
import SubscribeContent from "@/components/Common/SubscribeContent.vue";
import MainFooter from "@/components/Layouts/MainFooter.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";

export default defineComponent({
  name: "AboutUsPage",
  components: {
    NavbarOne,
    PageBanner,
    WhoWeAre,
    PoweringDailyLife,
    OurMission,
    OurVision,
    PartnerLogo,
    EnjoySports,
    FanFact,
    FAQ,
    OurLatestArticles,
    SubscribeContent,
    MainFooter,
    CopyRight,
  },
  setup() {
    useHead({
      title: "من نحن | خدمة IPTV وقنوات عربية بجودة HD و4K",
      meta: [
        {
          name: "description",
          content:
            "تعرف على خدماتنا في مجال اشتراكات IPTV ومشاهدة القنوات العربية والعالمية والأفلام والمسلسلات بجودة HD و4K مع تجربة مشاهدة مستقرة على جميع الأجهزة.",
        },
        {
          name: "keywords",
          content:
            "من نحن, IPTV, اشتراك IPTV, قنوات عربية, قنوات عالمية, أفلام, مسلسلات, بث مباشر, HD, 4K",
        },
        {
          property: "og:title",
          content: "من نحن | خدمة IPTV وقنوات عربية",
        },
        {
          property: "og:description",
          content:
            "خدمة ترفيهية متكاملة لمشاهدة القنوات العربية والعالمية والأفلام والمسلسلات بجودة عالية وثبات ممتاز.",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "robots",
          content: "index, follow",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://karamtv4k.com/about-us",
        },
      ],
    });

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const pageBannerImg = require("@/assets/images/page-banner-1.jpg");

    return {
      pageBannerImg,
    };
  },
});
</script>